import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import { css } from '@bd/bdui-styles/emotion';
import PagePhotoList from '../../PagePhotoList';
import PageSectionHeading from '../../PageSectionHeading';
// import { colors, typography } from '../styles';

const styles = css`
  margin: 45px 0;
  @media (min-width: 992px) {
    margin: 90px 0;
  }
`;

function PagePhotoGallery({ content }) {
  return (
    <div>
      {
        get(content, '[0].photos') &&
        <div className={styles}>
          <PageSectionHeading h3={get(content, '[0].section_heading')} />
          <div className="container">
            <div className="GalleryPhotos_Photos row">
              <div className="col-12 pb-5">
                <PagePhotoList
                  photos={get(content, '[0].photos')}
                />
              </div>
            </div>
          </div>
        </div>
      }
    </div>
  );
}

PagePhotoGallery.propTypes = {
  content: PropTypes.arrayOf(PropTypes.object).isRequired,
};

export default PagePhotoGallery;

// {
//   "_new": "fcf27dea2315d0eaa7dab7186f98816696fb32bd",
//   "array": [
//     {
//       "_new": "fcf27dea2315d0eaa7dab7186f98816696fb32bd",
//       "key": "section_heading",
//       "name": "Section Heading",
//       "type": "text"
//     },
//     {
//       "_new": "fcf27dea2315d0eaa7dab7186f98816696fb32bd",
//       "key": "photos",
//       "name": "Photos",
//       "type": "imageList"
//     }
//   ],
//   "key": "photo_gallery",
//   "name": "Photo Gallery",
//   "pageLoaderSectionName": "PagePhotoGallery",
//   "type": "collection"
// }



// WEBPACK FOOTER //
// ./src/components/PageLoader/Sections/PagePhotoGallery.section.js